import { observer } from "mobx-react";

import BaseComponent from "@component/BaseComponent";
import NoteList from "./List";

@observer
export default class Notes extends BaseComponent<PropsFromRouter> {
  render() {
    return (
      <>
        <NoteList match={this.props.match} />
      </>
    );
  }
}
